export interface OfferTag {
    ClientKey?: string;
    Id: string;
    OfferTagName: string;
}